import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import React, { createContext } from 'react';
import { useContextProps, Label as Label$1 } from 'react-aria-components';
import { LabelRequiredText } from './LabelRequiredText.es.js';

const label = "_label_ol4dq_1";
const asterisk = "_asterisk_ol4dq_19";
const styles = {
	label: label,
	asterisk: asterisk
};

const LabelContext = createContext(null);
const Label = (props) => {
  const [contextProps] = useContextProps(props, null, LabelContext);
  const { children, isCompact, isDisabled, isInvalid, isRequired, requiredText = "required" } = contextProps, domProps = __rest(contextProps, ["children", "isCompact", "isDisabled", "isInvalid", "isRequired", "requiredText"]);
  return React.createElement(
    Label$1,
    Object.assign({}, domProps, { className: styles.label, "data-compact": isCompact, "data-state": [isInvalid && "invalid", isDisabled && "disabled"].filter(Boolean).join(" ") || void 0, "data-zds": true }),
    children,
    isRequired && React.createElement("abbr", { className: styles.asterisk, title: "required" }, "*"),
    isRequired && requiredText && React.createElement(LabelRequiredText, { isDisabled }, requiredText)
  );
};

export { Label, LabelContext };
//# sourceMappingURL=Label.es.js.map
